var _rect, _rect2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgJolyai(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 143,
    height: 72,
    viewBox: "0 0 143 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 142,
    height: 71,
    rx: 9.5,
    fill: "white",
    stroke: "#12489E"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 18,
    width: 116,
    height: 36,
    fill: "url(#pattern0_115_99)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_115_99",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_115_99",
    transform: "matrix(0.0119363 0 0 0.0384615 -0.0192308 0)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_115_99",
    width: 87,
    height: 26,
    xlinkHref: "data:image/jpeg;base64,/9j/4AAQSkZJRgABAQEAYABgAAD/2wBDAAgGBgcGBQgHBwcJCQgKDBQNDAsLDBkSEw8UHRofHh0aHBwgJC4nICIsIxwcKDcpLDAxNDQ0Hyc5PTgyPC4zNDL/2wBDAQkJCQwLDBgNDRgyIRwhMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjL/wAARCAAaAFcDASIAAhEBAxEB/8QAHwAAAQUBAQEBAQEAAAAAAAAAAAECAwQFBgcICQoL/8QAtRAAAgEDAwIEAwUFBAQAAAF9AQIDAAQRBRIhMUEGE1FhByJxFDKBkaEII0KxwRVS0fAkM2JyggkKFhcYGRolJicoKSo0NTY3ODk6Q0RFRkdISUpTVFVWV1hZWmNkZWZnaGlqc3R1dnd4eXqDhIWGh4iJipKTlJWWl5iZmqKjpKWmp6ipqrKztLW2t7i5usLDxMXGx8jJytLT1NXW19jZ2uHi4+Tl5ufo6erx8vP09fb3+Pn6/8QAHwEAAwEBAQEBAQEBAQAAAAAAAAECAwQFBgcICQoL/8QAtREAAgECBAQDBAcFBAQAAQJ3AAECAxEEBSExBhJBUQdhcRMiMoEIFEKRobHBCSMzUvAVYnLRChYkNOEl8RcYGRomJygpKjU2Nzg5OkNERUZHSElKU1RVVldYWVpjZGVmZ2hpanN0dXZ3eHl6goOEhYaHiImKkpOUlZaXmJmaoqOkpaanqKmqsrO0tba3uLm6wsPExcbHyMnK0tPU1dbX2Nna4uPk5ebn6Onq8vP09fb3+Pn6/9oADAMBAAIRAxEAPwD3+uY1Px7oulX0lpKZ5ZIzhzEgIB9OSK6evn3Wp4HmlRYNs6zSGSXeTvBPHHbHNY1qko2SPSy7CQxEpc+yPYdL8baDq0qww3gimY4WOcbCT6DsT+NdDXy7K5ByDzXtPww8RT61oUtrduZLiyYIHY5LIR8ufcYI/KtINtXZeOy+NGPPTeh27ukaF3ZVUdSxwBTgQRkHINcL8Y/+ST69/wBc4/8A0alZw8V6/darYeFPCsGn/arbS4bq8utQ3mNAVXaoCkEk5B/GqPKPSXkSMAu6qCcAscc06vD/ABT4suvE3gm3j1G0S01TTfElvaXkcTEoXDH5lJ5wfeuw/wCE/utN1HxnZ6zDbxvokIu7Qxqw8+BlJXOScnOASMcmgD0CivJvEfiTxLqHgbwxaLdRaX4g19/ML2xMYhiVTIcZJI42A89zRqmr3viH4JW3iq01vUbG+s7FpH+yShBLKvysJOCSMqT260Aes0VzHgKzuLbwnZXF1qt/qM17FHcu97KHKFkXKrgDC+3PWigDbv31CLy3sYYZwMh45HKE+hB5/lXnV/8ADbUJ7APHJbG+mmMkpLEKi44Ucc8nr9K9RoqHBSd2dVDF1KCtA8/m+FelPoBhTeNT8rInMhx5mPTptz7Zqf4d+Dr/AMLf2g1+8LNcbAgiYngZ65A9a7mirWisKeLrTg4Sd0zy/Vfh74s1S3v9Bm8VRzeHb2585zcRNJdRpuDeWrE4xwOf/wBVaereCNWs/E0fiHwjqFpaXZs1sriC9iLxSouNpypBDDA/Ifj3tFBzHmL/AAquT4ZFm2qpNqlxrEeq3t08ZCyMDyqqOg9KwfiJp9n4v+KOk6LpFxJJdFPs2uJHGdqWyskq7m6euMH0HtXtlIFUEkKAT1OKAOO174e2PibxZY6nqxhudNs7NoItPaM43kg7859ABjHasFvhbq1v4SvvDOmeJYbXTbu6mkaNrEORE+MRgluMEHketeoUUAYHg/RdV0DRE07VdXj1Iw7UgdLYQ7I1UALgE56E596K36KAP//Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJolyai);
export default __webpack_public_path__ + "static/media/jolyai.0532a131d4769da355b9ee0245d1b86b.svg";
export { ForwardRef as ReactComponent };